module.exports = __webpack_public_path__ + "static/media/auto.2fbceaa2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/auto.svg
// module id = 254
// module chunks = 0